import { Aurelia, PLATFORM } from 'aurelia-framework';

export function configure(aurelia: any) {
    aurelia
        .globalResources(PLATFORM.moduleName("./aurelia-application-settings"))
        .globalResource(PLATFORM.moduleName("./kiosk"))
        .globalResource(PLATFORM.moduleName("./kiosk-types"))
        .globalResource(PLATFORM.moduleName("./kiosk-setting-types"))
        .globalResource(PLATFORM.moduleName("./kiosk-setting-names"))
        .globalResources(PLATFORM.moduleName("./processed-transaction-request"))
        .globalResources(PLATFORM.moduleName("./processed-transaction-by-last-four-request"))
        .globalResources(PLATFORM.moduleName("./tenant"))
        .globalResources(PLATFORM.moduleName("./user"))
        .globalResources(PLATFORM.moduleName("./web-api-response"));
}